<template>
	<div v-if="list.length" class="finance-month">
		<div class="section-label">期数</div>
		<OptionBox :options="options" :value="String(value)" @change="selectMonth" />
	</div>
</template>

<script>
import OptionBox from '@/components/OptionBox.vue'

export default {
	name: 'FinanceMonth',
	components: { OptionBox },
	props: {
		list: { type: Array, default: () => [] },
		value: { type: [String, Number], default: '' }
	},
	computed: {
		options() {
			return this.list.map(month => ({ value: String(month), label: `${month}期` }))
		}
	},
	methods: {
		selectMonth(month) {
			if (String(month) === String(this.value)) return
			this.$emit('change', month)
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';
.finance-month {
	margin-top: 40px;
	padding: 0 20px;
}
.section-label {
	margin-bottom: 10px;
	@include subtitle_2(1.5, 500, false);
}
</style>
